interface ButtonProps {
  label: string;
  color?:
    | 'ERROR'
    | 'SUCCESS'
    | 'NEUTRAL'
    | 'RED'
    | 'WARNING'
    | 'SUCCESS'
    | 'NONE';
}

interface SuccessPropType {
  title: string;
  message: string | JSX.Element;
  isOpen: boolean;
  confirmButtonStyle: ButtonProps;
  onConfirm: () => void;
}

const SuccessModal = (props: SuccessPropType) => {
  const { isOpen, message, title, onConfirm, confirmButtonStyle } = props;

  const colors = {
    NONE: 'border-gray-400 bg-white',
    ERROR: 'bg-brandError-500',
    SUCCESS: 'bg-brandSuccess-500  text-white',
    NEUTRAL: 'bg-neutral-500',
    RED: 'bg-brandRed-300  text-white',
    WARNING: 'bg-brandWarning-500',
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-20">
      <div
        id="confirm-modal-title"
        className="flex-row content-center gap-x-4 rounded-b-md rounded-t-2xl bg-primary-700 px-1 pb-1"
      >
        <h1 className="my-2 px-3 text-center text-xl font-semibold text-white">
          {title}
        </h1>

        <div className="w-96 rounded-md bg-white p-6">
          <span className="flex flex-col justify-center gap-y-5">
            <label className="mb-2 flex w-full flex-grow justify-center rounded-md text-center">
              {message}
            </label>

            <span className="flex flex-row items-center justify-center gap-x-2">
              <button
                data-testid="ok-modal-button"
                onClick={onConfirm}
                className={`rounded-md ${confirmButtonStyle && confirmButtonStyle.color ? colors[confirmButtonStyle.color] : colors['SUCCESS']} px-7 py-2`}
              >
                <b>{confirmButtonStyle.label}</b>
              </button>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
